import { Player } from "@presidents/game-engine/src/types";
import { User } from "../context/UserContext";
import { arrayRotate } from "./array-rotate";

export const getLocalPosition = (total: number) => {
  switch (total) {
    case 6:
    case 7:
      return total - 3;
    case 8:
      return 4;
    case 4:
    case 5:
      return total - 2;
    case 1:
    case 2:
    case 3:
    default:
      return total - 1;
  }
};

export default function arrangePlayers<T extends Array<Player>>(
  user: User | null | undefined,
  players: T,
  playerRanks: string[],
  targetPosition = getLocalPosition(players.length)
) {
  const sortedPlayers = players.slice().sort((a, z) => {
    if (playerRanks.length) {
      return playerRanks.indexOf(a.id) - playerRanks.indexOf(z.id);
    }
    return 0;
  });
  const sortedIndex = sortedPlayers.findIndex((p) => p.id === user?.uid);
  const rotatedArr = arrayRotate(sortedPlayers, sortedIndex - targetPosition);
  return rotatedArr as T;
}
